import React from 'react'
import { Col, FormGroup, Label, Input } from 'twyne-new.ui';

const CovalentForm = ({data, onChange, disabled}) => {
  return (
    <Col size="3">
        <FormGroup>
        <Label>Plc ID</Label>
        <Input type="text" value={data.plc_id || ''}
          onChange={(e) => onChange('plc_id', e.target.value)} disabled={disabled}
          />
        </FormGroup>
    </Col>
    
  );
}

export default CovalentForm;